import NotFound from 'common/NotFound';
import useFullPageLoader from 'common/UseFullPageLoader';
import React, { useEffect, useState } from 'react'
import { FaCoins } from 'react-icons/fa';
import Pagination from 'react-js-pagination';
import { useSearchParams } from 'react-router-dom';
import { coinListApi } from 'services/user';
import { dateFormat } from 'utils/dateFormat';
import findSerialNumber from 'utils/findSerialNumber';

const CoinHistory = ({ userId }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [loader, onShow, onHide] = useFullPageLoader();
  const [coinList, setCoinList] = useState([])
  const activePage = +searchParams.get("page") || 1;
  const [total, setTotal] = useState(0)

  //-------------Handel-Pagination-------------
  const handlePageChange = (event) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("page", event);
    setSearchParams(newParams);
  };
  // ----------Listing-API-------------------
  useEffect(() => {
    const fetchCoinList = async () => {
      const query = {
        page: activePage,
        // limit: limit,
      };
      onShow();
      try {
        const res = await coinListApi(userId, query);
        const { code, data } = res?.data;
        if (code === 200) {
          setCoinList(data?.data || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        onHide();
      }
    };
    if (userId) {
      fetchCoinList();
    }
  }, [activePage]);
  return (
    <div className="user-management-container">
      {/* <div className="page_title has_child mt-5">
        <h3>Approved Medicines</h3>
        <div className="tabContainer">
          <button
            className="button"
            type="button"
            onClick={() => setAddModal(true)}
          >
            Add Medicines
          </button>
        </div>
      </div> */}

      <div className="card">
        {loader}
        <div className="table-container">
          <table className="table custom_table">
            <thead>
              <tr>
                <th className="nowrap text-center">S.No</th>
                <th className="nowrap text-center">Reward Type</th>
                <th className="nowrap text-center">Date</th>
                <th className="nowrap text-center">Coin</th>
              </tr>
            </thead>

            <tbody>
              {coinList.length > 0 ? (
                coinList?.map((data, index) => {
                  const action = data?.action;
                  return (
                    <tr key={index}>
                      <td className="nowrap text-center">
                        {findSerialNumber(index, activePage, 10)}
                      </td>
                      <td className="nowrap text-center">
                        {data?.rewardType || "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        {dateFormat(data?.createdAt) || "N/A"}
                      </td>
                      <td className="nowrap text-center">
                        <span className={`fw-bold ${action === 'ADD' ? 'text-success' : 'text-danger'}`}>
                          {action === 'ADD' ? `+ ₹${data?.coin}` : `- ₹${data?.coin}`}
                        </span>
                      </td>


                    </tr>
                  );
                })
              ) : (
                <NotFound
                  cols={4}
                  msg={"Coin data not found"}
                  onHide={onHide}
                  icon={<FaCoins />}
                />
              )}
            </tbody>
          </table>
        </div>
      </div>
      {/* -----------pagination--------------- */}
      {total > 10 && (
        <div className="pagination-wrapper">
          <div className="Pagination">
            <Pagination
              activePage={activePage}
              previousLabel={"previous"}
              nextLabel={"next"}
              itemsCountPerPage={10}
              totalItemsCount={total}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              hideDisabled={true}
            />
          </div>
        </div>
      )}
    </div>
  )
}

export default CoinHistory